<div class="right-side p-5">
  <h2>Profile</h2>
  <div class="section">
    <form [formGroup]="form">
      <div class="card mb-3">
        <div class="card-header"><h2>Personal Details</h2></div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-4 mb-2">
              <label>UDYAM Number</label>
              <input type="text" id="txtudyamnumber" name="udyamnumber" [value]="msMeUserName" class="form-control" disabled>
            </div>
            <div class="col-md-4 mb-2">
              <label>Name of Owner</label>
              <input type="text" id="txtname" formControlName="name"
                     class="form-control">
              <div *ngIf="form.get('name')?.errors?.['required'] && form.get('name')?.touched" class="alert alert-danger">
                Name is required.
              </div>
              <div *ngIf="form.get('name')?.errors?.['pattern'] && form.get('name')?.touched" class="alert alert-danger">
                Name should not contain digits or special characters or multiple spaces between 2 characters
              </div>
            </div>
            <div class="col-md-4 mb-2">
              <label>Gender</label>

              <!-- Radio buttons for gender formControlName="gender" -->
              <div>
                <label><input type="radio" value="Male" formControlName="gender"> Male </label>
                <label class="mx-2"><input type="radio" value="Female" formControlName="gender"> Female </label>
                <label><input type="radio" value="Other" formControlName="gender"> Other </label>
              </div>
              <div *ngIf="form.get('gender')?.errors?.['required'] && form.get('gender')?.touched" class="alert alert-danger">
                Gender is required
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 mb-2">
              <label>Email</label>
              <input type="text" id="txtemail"  formControlName="email"
                     class="form-control">
              <div *ngIf="form.get('email')?.errors?.['required'] && form.get('email')?.touched" class="alert alert-danger">
                Email is required.
              </div>
              <div *ngIf="form.get('email')?.errors?.['pattern'] && form.get('email')?.touched" class="alert alert-danger">
                Enter Email address is invalid. Please re-enter the email address
              </div>
            </div>
            <div class="col-md-4 mb-2">
              <label>Are you a person with Disabilities?</label>

              <!-- Radio buttons for Yes/No  formControlName="areYouAPersonWithDisabilities"-->
              <div>
                <label class="me-2">
                  <input type="radio" formControlName="areYouAPersonWithDisabilities" [value]="true"> Yes
                </label>
                <label>
                  <input type="radio" formControlName="areYouAPersonWithDisabilities" [value]="false"> No
                </label>
                <div *ngIf="form.get('areYouAPersonWithDisabilities')?.errors?.['required'] && form.get('areYouAPersonWithDisabilities')?.touched" class="alert alert-danger">
                  This field is required.
                </div>
              </div>
            </div>

            <div class="col-md-4 mb-2">
              <label>Owner's Mobile Number</label>
              <input type="text" id="txtownersmobnum"  [value]="ownersMobileNumber" maxlength="10"
                     class="form-control" disabled>
              <div>
                <label for="chkboxwhatsappenabled">Is WhatsApp Enabled?</label>
                <input type="checkbox" id="chkboxwhatsappenabled" formControlName="isWhatsAppEnabled" (change)="onWhatsAppChange($event)" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 mb-2">
              <label>Alternate Contact Number</label>
              <input type="text" id="txtalternatemobnum" formControlName="alternateContactNumber" (keypress)="numberOnly($event)"
                     class="form-control" maxlength="10">
              <div *ngIf="form.get('alternateContactNumber')?.errors?.['required'] && form.get('alternateContactNumber')?.touched" class="alert alert-danger">
                Enter WhatsApp number or check Mobile Number as per Udyam as Whatsapp number.
              </div>
              <div *ngIf="form.get('alternateContactNumber')?.errors?.['pattern'] && form.get('alternateContactNumber')?.touched" class="alert alert-danger">
                Enter Valid mobile number.Mobile number should be 10 digits only, first digit should be non-zero
              </div>
            </div>
            <div class="col-md-4 mb-2">
              <label>Social Category</label>
              <!--<select id="txtsocialcategory" class="form-select" formControlName="socialCategory">
                <option value="" disabled selected>Select Social Category</option>
                <option *ngFor="let type of socialCategory" [value]="type.socialCategoryId">
                  {{ type.socialCategoryName }}
                </option>
              </select>-->

              <ng-select [items]="socialCategory"
                         bindLabel="socialCategoryName"
                         bindValue="socialCategoryId"
                         formControlName="socialCategory"
                         [searchable]="true"
                         placeholder="--select--"
                         appendTo="body">
              </ng-select>
              <div *ngIf="form.get('socialCategory')?.errors?.['required'] && form.get('socialCategory')?.touched" class="alert alert-danger">
                Select Social Category is required.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card mb-3">
        <div class="card-header">  <h2>Enterprise Details</h2></div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-4 mb-2">
              <label>Name of Enterprise</label>
              <input type="text" id="txtnameOfEnterprise" formControlName="nameOfEnterprise"
                     class="form-control">
              <div *ngIf="form.get('nameOfEnterprise')?.errors?.['required'] && form.get('nameOfEnterprise')?.touched" class="alert alert-danger">
                Enterprise Name is required.
              </div>
              <div *ngIf="form.get('nameOfEnterprise')?.errors?.['pattern'] && form.get('nameOfEnterprise')?.touched" class="alert alert-danger">
                Invalid Enterprise Name
              </div>
            </div>
            <div class="col-md-4 mb-2">
              <label>Type of Organization</label>
              <!-- Dropdown for Type of Organization -->
              <!--<select id="typeOfOrganization" class="form-select" formControlName="typeofOrganization"
                      (change)="onOrganizationChange($event)">
                <option *ngFor="let org of organizationType" [value]="org.organizationTypeId">
                  {{ org.organizationTypeName }}
                </option>
              </select>-->
              <ng-select [items]="organizationType"
                         bindLabel="organizationTypeName"
                         bindValue="organizationTypeId"
                         formControlName="typeofOrganization"
                         [searchable]="true"
                         placeholder="--select--"
                         (change)="onOrganizationChange($event)" appendTo="body">
              </ng-select>
              <div *ngIf="form.get('typeofOrganization')?.errors?.['required'] && form.get('typeofOrganization')?.touched" class="alert alert-danger">
                Organization Type is required.
              </div>
            </div>

            <div class="col-md-4 mb-2">
              <label>Type of Enterprise</label>

              <!-- Dropdown for Type of Enterprise -->

              <!--<select id="typeOfEnterprise" class="form-select" formControlName="typeOfEnterprise" (change)="onEnterpriseChange($event)">
                <option value="" disabled selected>Select Enterprise Type</option>
                <option *ngFor="let enterprise of enterpriseType" [value]="enterprise.id">
                  {{ enterprise.name }}
                </option>
              </select>-->

              <ng-select [items]="enterpriseType"
                         bindLabel="name"
                         bindValue="id"
                         formControlName="typeOfEnterprise"
                         [searchable]="true"
                         placeholder="--select--"
                         (change)="onEnterpriseChange($event)" appendTo="body">
              </ng-select>

              <div *ngIf="form.get('typeOfEnterprise')?.errors?.['required'] && form.get('typeOfEnterprise')?.touched" class="alert alert-danger">
                Enterprise Type is required.
              </div>
            </div>

          </div>

          <div class="row">
            <div class="col-md-4 mb-2">
              <label>Official Address of Enterprise</label>
              <!--<input type="text" id="txtentaddress" formControlName="officialAddressOfEnterprise"
         class="form-control">-->
              <textarea id="txtentaddress" formControlName="officialAddressOfEnterprise" class="form-control"></textarea>

              <div *ngIf="form.get('officialAddressOfEnterprise')?.errors?.['required'] && form.get('officialAddressOfEnterprise')?.touched" class="alert alert-danger">
                Name is required.
              </div>
              <div *ngIf="form.get('officialAddressOfEnterprise')?.errors?.['pattern'] && form.get('officialAddressOfEnterprise')?.touched" class="alert alert-danger">
                Official Address can contain alphanumeric characters or .,/ or whitespaces
              </div>
            </div>
            <div class="col-md-4 mb-2">
              <label>State</label>
              <input type="text" id="txtstate" formControlName="stateName" class="form-control">
            </div>
            <div class="col-md-4 mb-2">
              <label>District</label>

              <!-- Dropdown for District -->
              <!--<select id="district" class="form-select" formControlName="districtId"
                      (change)="GetBlocks($event,'select')">
                <option *ngFor="let district of districtsBasedOnState" [value]="district.districtCode">
                  {{ district.districtName }}
                </option>
              </select>-->

              <ng-select [items]="districtsBasedOnState"
                         bindLabel="districtName"
                         bindValue="districtCode"
                         formControlName="districtId"
                         [searchable]="true"
                         placeholder="--select--"
                         (change)="GetBlocks($event,'select')" appendTo="body">
              </ng-select>

              <div *ngIf="form.get('districtId')?.errors?.['required'] && form.get('districtId')?.touched" class="alert alert-danger">
                Name is required.
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 mb-2">
              <label>Block</label>

              <!-- Dropdown for Block -->
              <!--<select id="block" class="form-select"
                      formControlName="block" (change)="onBlockChange($event)">
                <option *ngFor="let block of blocksBasedonDistricts" [value]="block.blockId">
                  {{ block.blockName }}
                </option>
              </select>-->

              <ng-select [items]="blocksBasedonDistricts"
                         bindLabel="blockName"
                         bindValue="blockId"
                         formControlName="block"
                         [searchable]="true"
                         placeholder="--select--"
                         (change)="onBlockChange($event)" appendTo="body">
              </ng-select>

            </div>

            <div class="col-md-4 mb-2">
              <label>City</label>
              <input type="text" id="txtcity" formControlName="city"
                     class="form-control">
              <div *ngIf="form.get('city')?.errors?.['required'] && form.get('city')?.touched" class="alert alert-danger">
                City is required.
              </div>
              <div *ngIf="form.get('city')?.errors?.['pattern'] && form.get('city')?.touched" class="alert alert-danger">
                City should not contain digits or special characters
              </div>
            </div>
            <div class="col-md-4 mb-2">
              <label>Pincode</label>
              <input type="text" id="txtpin" formControlName="pin" (keypress)="numberOnly($event)" maxlength="6"
                     class="form-control">
              <div *ngIf="form.get('pin')?.errors?.['required'] && form.get('pin')?.touched" class="alert alert-danger">
                Pin is required.
              </div>
              <div *ngIf="form.get('pin')?.errors?.['pattern'] && form.get('pin')?.touched" class="alert alert-danger">
                Please enter 6 digit pin that starts with 4
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 mb-2">
              <label>DIC</label>
              <input type="text" id="txtdic" formControlName="dic"
                     class="form-control">
              <div *ngIf="form.get('dic')?.errors?.['required'] && form.get('dic')?.touched" class="alert alert-danger">
                DIC is required.
              </div>
            </div>

          </div>
          <div class="row">
            <div class="col-md-4 mb-2" *ngIf="!showDateOfComm">
              <label>Date of Commencement</label>
              <input type="date" id="txtdateOfCommencement" formControlName="dateOfCommencement" (keydown)="blockManualInput($event)"
                     class="form-control">
            </div>
            <div class="col-md-4 mb-2" *ngIf="showDateOfComm">
              <label>Date of Commencement</label>
              <input type="text" id="txtdateOfCommencement" formControlName="dateOfCommencement" (keydown)="blockManualInput($event)"
                     class="form-control">
            </div>
            <div class="col-md-4 mb-2" *ngIf="!showDateOfIncorp">
              <label>Date of Incorporation</label>
              <input type="date" id="txtdateofIncorporation" formControlName="dateOfIncorporation" (keydown)="blockManualInput($event)"
                     class="form-control">
            </div>
            <div class="col-md-4 mb-2" *ngIf="showDateOfIncorp">
              <label>Date of Incorporation</label>
              <input type="text" id="txtdateofIncorporation" formControlName="dateOfIncorporation" (keydown)="blockManualInput($event)"
                     class="form-control">
            </div>
            <div class="col-md-4 mb-2">
              <label>Major Activity</label>
              <div>
                <input type="radio"
                       value="Manufacturing"
                       formControlName="majorActivity"                      
                       (change)="usr_obj.list1[0].majorActivity = 'Manufacturing'"> Manufacturing

                <input type="radio"
                       value="Services"
                       formControlName="majorActivity"
                       (change)="usr_obj.list1[0].majorActivity = 'Services'"> Services

                <input type="radio"
                       value="Trading"
                       formControlName="majorActivity"
                       (change)="usr_obj.list1[0].majorActivity = 'Trading'"> Trading
              </div>

              <!-- Display error message if the field is required and has been touched -->
              <div *ngIf="form.get('majorActivity')?.errors?.['required'] && form.get('majorActivity')?.touched" class="alert alert-danger">
                This field is required.
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 mb-2">
              <label>Investment Cost</label>
              <input type="text" id="txtinvestmentcost" formControlName="investmentCost" (keypress)="numberOnly($event)"
                     class="form-control">
            </div>
            <div class="col"></div>
            <div class="col"></div>
          </div>


          <!--<div class="row">
        <div class="col-md-4 mb-2">
          <label>Are you an Exporter ?</label>
        </div>
        <div class="col-md-4 mb-2"> <label>IEC</label></div>

      </div>

      <div class="row">
        <div class="col-md-4 mb-2">
          <label class="me-2">
            <input type="radio" name="areyouanexporter" value="Yes"
                   [checked]="usr_obj.list1[0].areYouAnExporter === true"
                   (change)="onExporterChange($event)"> Yes
          </label>
          <label>
            <input type="radio" name="areyouanexporter" value="No"
                   [checked]="usr_obj.list1[0].areYouAnExporter === false"
                   (change)="onExporterChange($event)"> No
          </label>
          <div *ngIf="form.get('areYouAnExporter')?.errors?.['required'] && form.get('areYouAnExporter')?.touched" class="alert alert-danger">
            This field is required.
          </div>
        </div>
        <div class="col-md-4 mb-2">
          <input type="text" id="txtiec" name="iec" formControlName="iec" (keypress)="numberOnly($event)" maxlength="10"
                 class="form-control">
          <div *ngIf="form.get('iec')?.errors?.['required'] && form.get('iec')?.touched" class="alert alert-danger">
            IEC code is required.
          </div>
          <div *ngIf="form.get('iec')?.errors?.['pattern'] && form.get('iec')?.touched" class="alert alert-danger">
            IEC code should be 10 digits only
          </div>
        </div>

      </div>-->
        </div>
      </div>

      <div class="card mb-3">
        <div class="card-header"> <h2>NIC Details</h2></div>
        <div class="card-body">
          <!-- NIC Details Table -->


          <div class="row text-start">
            <div class="col-md-4 mb-2">
              <label class="nowrap">NIC Code <span class="text-danger">*</span></label>
              <!--<select id="txtNICCode" class="form-select" formControlName="nicCode" (change)="onNICCodeChange($event)">
                <option value="" disabled selected>Select NIC Code</option>
                <option *ngFor="let type of niclist" [value]="type.nicCode">
                  {{ type.nicCode }} ({{ type.subClassName }})
                </option>
              </select>-->
            <ng-select [items]="niclist"
                       bindLabel="nicCode"
                       bindValue="nicCode"
                       formControlName="nicCode"
                       [searchable]="true"
                       placeholder="--select--"
                       (change)="onNICCodeChange($event)"
                       appendTo="body">
              <ng-template ng-label-tmp let-item="item">
                {{ item.nicCode }} ({{ item.subClassName }})
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{ item.nicCode }} ({{ item.subClassName }})
              </ng-template>
            </ng-select>
              <div *ngIf="nicEntries.length === 0" style="color: red;">
                At least one NIC code must be added.
              </div>
            </div>
            <div class="col-md-4 mb-2">
              <button class="btn btn-primary btn-sm btn-sm mt-4 me-2" (click)="addNIC()" [disabled]="registrationStatus"><i class="bi bi-plus-lg"></i> Add</button>
              <button type="button" class="btn btn-secondary btn-sm mt-4" (click)="generatePDF()">
                <i class="bi bi-table"></i> 
                Show All NIC Data
              </button>
            </div>

          </div>

          <div class="table-responsive">
            <table class="table table-striped table-bordered table-hover">
              <thead>
                <tr>
                  <th class="text-center">Sr. No.</th>
                  <th class="text-center">NIC Code</th>
                  <!--<th class="text-center">Sector Code</th>-->
                  <th class="text-center">Sector</th>
                  <th class="text-center">Division</th>
                  <th class="text-center">Group</th>
                  <th class="text-center">Class</th>
                  <th class="text-center">Sub Class</th>

                  <th class="text-center" style="width:120px">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let nic of nicEntries; let i = index">
                  <td class="text-center">{{ i + 1 }}</td>
                  <td class="text-center">{{ nic.nicCode }}</td>

                  <!--<td class="text-center">{{ nic.sectorCode }}</td>-->
                  <td class="text-center">{{ nic.sectorName }}</td>
                  <td class="text-center">{{ nic.divisionName }}</td>
                  <td class="text-center">{{ nic.groupName }}</td>
                  <td class="text-center">{{ nic.className }}</td>
                  <td class="text-center">{{ nic.subClassName }}</td>
                  <td class="text-center">
                    <button class="btn btn-danger btn-sm" (click)="openConfirmationDialog('nicEntry', i)" [disabled]="registrationStatus"><i class="bi bi-trash"></i> Remove</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="card mb-3">
        <div class="card-header"> <h2>Plant Details</h2></div>
        <div class="card-body">
          <!-- Plant Details Table -->
          <div class="row text-start" *ngIf="!registrationStatus">
            <div class="col-md-5 mb-2">
              <label class="nowrap" for="plantUnitName">Plant Unit Name: <span class="text-danger">*</span></label>
              <input id="plantUnitName" class="form-control" formControlName="plantUnitName" placeholder="Plant Unit Name" />
              <div *ngIf="form.get('plantUnitName')?.invalid && form.get('plantUnitName')?.touched" class="alert alert-danger">
                <ng-container *ngIf="form.get('plantUnitName')?.errors?.['required']">
                  Plant unit is required.
                </ng-container>
                <ng-container *ngIf="form.get('plantUnitName')?.errors?.['pattern']">
                  Plant unit is not in the correct format.
                </ng-container>
              </div>
            </div>
            <div class="col-md-5 mb-2">
              <label class="nowrap" for="locationOfPlantUnit">Address/Location: <span class="text-danger">*</span></label>
              <input id="locationOfPlantUnit" class="form-control" formControlName="locationOfPlantUnit" placeholder="Location" />
              <div *ngIf="form.get('locationOfPlantUnit')?.invalid && form.get('locationOfPlantUnit')?.touched" class="alert alert-danger">
                <ng-container *ngIf="form.get('locationOfPlantUnit')?.errors?.['required']">
                  Location is required.
                </ng-container>
                <ng-container *ngIf="form.get('locationOfPlantUnit')?.errors?.['pattern']">
                  Location is not in the correct format.
                </ng-container>
              </div>
            </div>
            <div class="col-md-2 mb-2">
              <button (click)="addPlantUnit()" class="btn btn-primary mt-4" [disabled]="registrationStatus">Add</button>
            </div>
          </div>

          <div class="table-responsive" *ngIf="plantUnit.length > 0">
            <table class="table table-striped table-bordered table-hover">
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th class="text-center">Plant Name</th>
                  <th class="text-center">Plant Location</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let plant of plantUnit; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td class="text-center">{{ plant.plantName }}</td>
                  <td class="text-center">{{ plant.plantLocation }}</td>
                  <td>
                    <button (click)="openConfirmationDialog('plantUnit',i)" class="btn btn-danger btn-sm" [disabled]="registrationStatus"><i class="bi bi-trash"></i> Remove</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="card-body" *ngIf="plantUnit.length === 0 && registrationStatus">
          N/A
        </div>
      </div>


      <div class="card mb-3">
        <div class="card-header"> <h2>Interests</h2></div>
        <div class="card-body">
          <!-- Interests Table -->
          <div class="row text-start mb-3">
            <div class="col-md-5 mb-2">
              <label class="nowrap">Interest/Component</label>
              <div class="interest-selection-box">
                <div *ngFor="let interest of filteredInterests" class="form-check">
                  <input type="checkbox"
                         class="form-check-input"
                         [checked]="interest.selected"
                         (change)="toggleInterestSelection(interest, $event)" />
                  <label class="form-check-label">
                    {{ interest.interestName }}
                  </label>
                </div>
              </div>
            </div>

            <div class="col-md-1 mb-2 text-center">
              <button class="btn btn-sm btn-primary my-2 me-2" (click)="moveSelectedToRight()">
                <i class="bi bi-arrow-right"></i>
              </button>
              <button class="btn btn-sm btn-primary my-2" (click)="moveSelectedToLeft()">
                <i class="bi bi-arrow-left"></i>
              </button>
            </div>
            <!--<div class="col-md-5 mb-2">
    <label class="nowrap">Selected Interests</label>
    <div class="selected-interests-box">
      <div *ngFor="let selectedInterest of selectedInterests" class="form-check">
        <input type="checkbox"
               class="form-check-input"
               [checked]="selectedInterest.selected"
               [disabled]="selectedInterest.isEnrolled || selectedInterest.isSpotted"
               (change)="toggleInterestSelection(selectedInterest, $event)" />
        <label class="form-check-label">
          {{ selectedInterest.interestName }}
        </label>
      </div>
    </div>
  </div>-->




          <div class="col-md-5 mb-2">
            <label class="nowrap">Selected Interests</label>
            <div class="selected-interests-box">
              <div *ngFor="let selectedInterest of selectedInterests" class="form-check">

                <input type="checkbox"
                       class="form-check-input"
                       [checked]="selectedInterest.selected"
                       [disabled]="selectedInterest.isLocked"
                       (change)="toggleInterestSelection(selectedInterest, $event)" />
                <label class="form-check-label">
                  {{ selectedInterest.interestName }}
                </label>

              </div>
            </div>
          </div>



            <!--<div class="col-md-5 mb-2">
    <label class="nowrap">Selected Interests</label>
    <div class="selected-interests-box">
      <div *ngFor="let selectedInterest of selectedInterests" class="form-check">
        <input type="checkbox"
               class="form-check-input"
               [checked]="selectedInterest.selected"
               (change)="toggleInterestSelection(selectedInterest, $event)" />
        <label class="form-check-label">
          {{ selectedInterest.interestName }}
        </label>
      </div>
    </div>
  </div>-->
          </div>

          <button id="btnsave" type="submit" (click)="UpdateInterest()" class="btn btn-primary btn-sm me-2"><i class="bi bi-person-check"></i> Update Interest</button>
        </div>        
      </div>

      <!--<div class="card mb-3" *ngIf="registrationStatus">
        <div class="card-header"> <h2 class="text-start">Interests</h2></div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-striped table-bordered table-hover">
              <thead>
                <tr>
                  <th class="text-center">Interest</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let unit of selectedInterests">
                  <td class="text-center">{{ unit.interestName }}</td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>-->

      <div class="card mb-3">
        <div class="card-header"> <h2 class="text-start">Udyam Certificate</h2></div>
        <div class="card-body">
          <div class="row text-start">

            <div *ngIf="!registrationStatus">
              <div class="col-md-4 mb-2">
                <label for="udyamCertificate">Upload Udyam Certificate (PDF, max 10 MB): <span class="text-danger">*</span></label>
              </div>
              <div class="col-md-4 mb-2">
                <input type="file"
                       id="udyamCertificate"
                       (change)="onUdyamFileChange($event)"
                       accept=".pdf"
                       formControlName="udyamCertificate"
                       class="form-control" />
                <div *ngIf="form.controls['udyamCertificate'].invalid && form.controls['udyamCertificate'].touched"
                     class="alert alert-danger">
                  Upload the Udyam Certificate.
                </div>
                <div *ngIf="uploadError" class="alert alert-danger">{{ uploadError }}</div>
              </div>
            </div>

          </div>

          <div class="table-responsive" >
            <table class="table table-striped table-bordered table-hover">
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th class="text-center">Document Type</th>
                  <!--<th class="text-center">Document Name</th>-->
                  <th class="text-center">Download</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-center">1</td>
                  <td class="text-center">Udyam Certificate</td>
                  <!--<td class="text-center">{{ 'Udyam Certificate'|| 'No file uploaded' }}</td>-->
                  <td class="text-center">
                    <a (click)="onDownload(form.get('udyamCertificatePath')?.value ,'UdyamCertificate'); $event.preventDefault()"
                       style="cursor: pointer"
                       [ngClass]="{'disabled-link': !form.get('udyamCertificatePath')?.value}"
                       class="btn btn-warning btn-sm mt-1">
                      <i class="bi bi-download"></i> Download
                    </a>
                    <button class="btn btn-primary btn-sm mt-1 mx-1"  [disabled]="!form.get('udyamCertificatePath')?.value"
                            (click)="openFilePreviewDialog(form.get('udyamCertificatePath')?.value , 'UdyamCertificate.pdf')">
                    <i class="bi bi-eye"></i> View File</button>
                  </td>
                  <td class="text-center">
                    <button (click)="removeUdyamCertificate()" class="btn btn-danger btn-sm" [disabled]="registrationStatus">
                      <i class="bi bi-trash"></i> Remove
                    </button>

                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!--*ngIf="form.get('documents')?.value.length > 0  && registrationStatus" --First Table
       !registrationStatus" --first Table + upload = show all
      *ngIf="form.get('documents')?.value.length === 0  && registrationStatus" -- N/A-->

      <div class="card mb-3">
        <div class="card-header"> <h2>Other Supporting Documents</h2></div>
        <div class="card-body">
          <!-- File Details -->
          <div class="table-responsive">
            <table *ngIf="form.get('documents')?.value.length> 0  " class="table table-striped table-bordered table-hover">
              <thead>
                <tr>
                  <th class="text-center">Sr. No.</th>
                  <th class="text-center">Document Type</th>
                  <th class="text-center">Document Name</th>
                  <th class="text-center">Download</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let file of form.get('documents')?.value ; let i = index ">
                  <td>{{ i + 1 }}</td>
                  <td class="text-center">{{ file.documentType }}</td>
                  <td class="text-center">{{ file.documentName }}</td>
                  <td class="text-center">
                    <a *ngIf="file.documentPath"
                       (click)="onDownload(file.documentPath, file.documentName); $event.preventDefault()" style="cursor: pointer" class="btn btn-warning btn-sm mt-1">
                      <i class="bi bi-download"></i> Download
                    </a>
                    <button class="btn btn-primary btn-sm mx-1 mt-1" (click)="openFilePreviewDialog(file.documentPath, file.documentName)"><i class="bi bi-eye"></i> View File</button>
                  </td>
                  <td class="text-center">
                    <button (click)="removeDocument(i)" class="btn btn-danger btn-sm" [disabled]="registrationStatus"><i class="bi bi-trash"></i> Remove</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div *ngIf="!registrationStatus">
            <div class="row text-start">
              <!-- Form array for dynamic document entries -->
              <div formArrayName="newDocuments">
                <div *ngFor="let doc of newDocuments.controls; let i = index" [formGroupName]="i">
                  <div class="row text-start">
                    <!-- Document Name -->
                    <div class="col-md-4 mb-2">
                      <label class="nowrap" for="docName{{ i }}">Document Name: </label>
                      <input id="docName{{ i }}" class="form-control" formControlName="name" placeholder="Enter Document Name" />
                      <div *ngIf="doc.get('name')?.invalid && doc.get('name')?.touched" class="alert alert-danger">
                        Document name is required.
                      </div>
                    </div>

                    <!-- File Upload -->
                    <div class="col-md-4 mb-2">
                      <label class="nowrap" for="docFile{{ i }}">Upload File (PDF, max 10 MB): </label>
                      <input type="file" id="docFile{{ i }}" (change)="onFileChange($event, i)" accept=".pdf" class="form-control" />
                      <div *ngIf="doc.get('file')?.invalid && doc.get('file')?.touched" class="alert alert-danger">
                        File is required.
                      </div>
                      <div *ngIf="form.get('udyamCertificate')?.value" class="mt-2">
                        <strong>Uploaded File:</strong> {{ doc.get('file')?.value?.name  }}
                      </div>
                    </div>

                    <!-- Remove Button -->
                    <div class="col-md-4 mb-2">
                      <button type="button" class="btn btn-danger btn-sm mt-md-4" (click)="removeNewDocument(i)"><i class="bi bi-trash"></i> Remove</button>
                    </div>
                  </div>

                </div>
              </div>
              <div class="col-md-4 mb-2">
                <button type="button" class="btn btn-primary text-start" (click)="addMoreDocuments()" [disabled]="(documents.length + newDocuments.length) >= 5">
                  Add More
                </button>
              </div>
            </div>

            <!-- Displaying New Documents -->
            <table class="table table-striped table-bordered table-hover">
              <thead>
                <tr>
                  <th class="text-center">#</th>
                  <th class="text-center">Document Name</th>
                  <th class="text-center">File</th>
                  <th class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let doc of newDocuments.controls; let i = index">
                  <td class="text-center">{{ i + 1 }}</td>
                  <td class="text-center">{{ doc.get('name')?.value  }}</td>
                  <td class="text-center">{{ doc.get('file')?.value?.name }}</td>
                  <td class="text-center">
                    <button (click)="removeNewDocument(i)" class="btn btn-danger btn-sm">
                      <i class="bi bi-trash"></i> Remove
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>

        

        <div class="card-body" *ngIf="form.get('documents')?.value.length=== 0  && registrationStatus">
        N/A
        </div>
      </div>
      <div class="card mb-3">
        <div class="card-header"><h2>Status of your Application</h2></div>
        <div class="card-body">
          Status :
          <input type="text" id="txtstatus" formControlName="status" class="form-control" >
          Comments by Approver: <input type="text" id="txtremarks" formControlName="remarks" class="form-control" >
          <button id="btnsave" type="submit" (click)="ViewStatusHistory()" class="btn btn-primary btn-sm me-2 mt-2" [disabled]="registrationStatus"><i class="bi bi-clock-history"></i> View Status History</button>
        </div>
      </div>
    </form>

    <button id="btnsave" type="submit" (click)="Update(form)" class="btn btn-primary me-2"  [disabled]="registrationStatus"><i class="bi bi-person-check"></i> Update</button>
    <button id="btnsave" type="submit" (click)="ReloadProfile()" class="btn btn-danger"  [disabled]="registrationStatus"><i class="bi bi-x-circle"></i> Cancel</button>

  </div>
</div>
